import CustomAlert from "./CustomAlert.vue";

export function createCustomAlert() {
    return {
        install(app) {
            app.component('CustomAlert', CustomAlert);
        }
    }
}
